import React from 'react'
import TempBreadcrumbWMO from './TempBreadcrumbWMO'
import { 
  Container,
  Heading,
  ReturnDetailsBox,
  OrderInfo,
  InfoText,
  VerticalLine,
} from "./style/ReturnDetailsWMO.css"
import ReturnInfoWMO from './ReturnInfoWMO'
import ReturnStatusWMO from './ReturnStatusWMO'

export default function ReturnDetailsWMO({
  isDesktop,
  linkBreadcrumb,
  Link,
  exitReturnDetails,
  returnData,
  creditStatus,
  returnRequestStatus,
  isCustomerTrackOrderRoute
}) {
  const { merchantOrderId, date } = returnData.order
  const d = new Date(date)
  const options = {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  }
  const orderDate = d.toLocaleDateString('en-US', options)

  return (
    <Container>
      {
        !isCustomerTrackOrderRoute && linkBreadcrumb.length > 0 && (
          <TempBreadcrumbWMO
            links={linkBreadcrumb}
            Link={Link}
            exitReturnDetails={exitReturnDetails}
          />
        )
      }
      <Heading>Return Details</Heading>
      <ReturnDetailsBox>
        <OrderInfo>
          <InfoText>
            Order #:{' '}
            <span>{merchantOrderId}</span>
          </InfoText>
          <VerticalLine>|</VerticalLine>
          <InfoText>
            Order Date:{' '}
            <span>{orderDate}</span>
          </InfoText>
        </OrderInfo>
        <ReturnInfoWMO
          orderDetails={returnData}
          creditStatus={creditStatus}
          returnRequestStatus={returnRequestStatus}
        />
        <ReturnStatusWMO 
          orderDetails={returnData}
          isDesktop={isDesktop}
          exitReturnDetails={exitReturnDetails}
        />
      </ReturnDetailsBox>
    </Container>
  )
}
